import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function Visa(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_1984_103)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M2.408 14.156a7 7 0 017.427-9.109 1 1 0 10.22-1.988 9 9 0 104.675 15.949c1.557-.052 2.677-.527 3.552-.898.249-.106.477-.203.69-.28.54-.193.999-.278 1.536-.179.555.104 1.275.421 2.287 1.195a.75.75 0 10.91-1.192c-1.113-.851-2.05-1.315-2.923-1.477-.893-.166-1.637-.002-2.317.242-.304.11-.591.23-.877.35-.384.16-.765.32-1.18.45a9.036 9.036 0 001.58-3.989l.273-.114c.158-.066.305-.128.436-.18.422-.168.774-.28 1.13-.315.658-.065 1.516.115 2.967 1.225a.75.75 0 10.912-1.192c-1.614-1.233-2.845-1.642-4.027-1.525-.566.055-1.072.228-1.537.413l-.08.032a9.015 9.015 0 00-.71-3.092c.313-.115.599-.236.861-.346l.019-.008c.527-.222.93-.389 1.343-.47.719-.14 1.608-.045 3.22 1.188a.75.75 0 00.91-1.192c-1.814-1.387-3.133-1.719-4.418-1.468-.579.113-1.117.34-1.608.547l-.03.013c-.332.14-.658.277-1.005.396a8.962 8.962 0 00-.417-.596 1.004 1.004 0 00-.135-.144l.655-.738a1 1 0 00-1.494-1.328l-7.296 8.207-1.75-1.75a1 1 0 00-1.414 1.414l2.5 2.5a1 1 0 001.454-.043l6.003-6.752a7 7 0 11-12.341 6.245z",
    clipRule: "evenodd"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_1984_103"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default Visa;